module.exports = __webpack_public_path__ + "static/media/undercover_spy.f8efc329.png";